export default {
  path: "/license",
  redirect: "/license/index",
  meta: {
    icon: "mdi:license",
    showLink: true,
    title: "license管理",
    rank: 20
  },
  children: [
    {
      path: "/license/index",
      name: "license",
      component: () => import("@/views/license/index.vue"),
      meta: {
        title: "license管理"
      }
    }
  ]
} satisfies RouteConfigsTable;
